import { RACE_CORE_PRESET } from './race/preset'
import type { BoggleChallengeCoreInfo } from './types'

export function getRaceChallengeIntervalTimeInfo(
  intervalTimeSeconds: number,
): BoggleChallengeCoreInfo<number> {
  if (intervalTimeSeconds < RACE_CORE_PRESET.intervalTimeSeconds) {
    return {
      id: 'fast-race',
      tierLabel: 'Short',
    }
  } else if (intervalTimeSeconds > RACE_CORE_PRESET.intervalTimeSeconds) {
    return {
      id: 'slow-race',
      tierLabel: 'Long',
    }
  } else {
    return {
      id: 'normal-race',
      tierLabel: 'Normal',
    }
  }
}
